import { useQuery } from '@apollo/client';
import { getProperties, Property } from 'vendor-marketplace-shared-library';

import FilterMultiSelect from './FilterMultiSelect';

export default function PropertySelector({
  value,
  onChange,
}: {
  value: string[];
  onChange: (value: string[]) => void;
}) {
  const { data } = useQuery(getProperties);

  return (
    <FilterMultiSelect
      htmlId={'property-select'}
      label={'Properties'}
      options={
        data?.getProperties.map((property: Property) => ({
          id: property.id,
          label: property.name,
        })) || []
      }
      value={value}
      onChange={onChange}
    />
  );
}
